import React, { useState } from "react"
import StudentsLayout from "./StudentLayoutTab/StudentsLayout"
import Tabs from '../../../UI/Tabs/Tabs';
import classes from "./StudentLayoutPage.module.css"
import AnswerReport from "./AnswerReport/AnswerReport"
import ReflectionReportTab from "./ReflectionReport/ReflectionReportTab/ReflectionReportTab"

const StudentLayoutPage = () => {
    const [currentTab, setCurrentTab] = useState(1)

    const StudentLayoutTypeEnum = {
        StudentsLayout: 1,
        AnswerReport: 2,
        ReflectionReport: 3
    }
    return (
        <>
            <div className={classes.StudentLayoutPage}>
                <Tabs setCurrentTab={setCurrentTab} currentTab={currentTab} typeEnum={StudentLayoutTypeEnum} />
                {currentTab == StudentLayoutTypeEnum.StudentsLayout && <StudentsLayout />}
                {currentTab == StudentLayoutTypeEnum.AnswerReport && <AnswerReport />}
                {currentTab == StudentLayoutTypeEnum.ReflectionReport && <ReflectionReportTab />}
            </div>
        </>
    )
}
export default StudentLayoutPage